import "../styles/ExamScore.css";

import React, { useEffect, useState } from "react";
import { getExamReattempts, startReattemptWrong } from "../services/ExamScoreApi";
import { selectTest, setReattemptId } from "../store/testSelectionSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import TestResult from "./TestResult";

const ExamScore = () => {
	const { firstName, lastName } = useSelector((state) => state.userDetails);
	const [selectedMenu, setSelectedMenu] = useState("testResult");
	const [reattempts, setReattempts] = useState([]);
	const [wrongQuestions, setWrongQuestions] = useState(null);
	const [examName, setExamName] = useState("");
	const { examId, selectedTest, attempt, reattemptId } = useSelector(
		(state) => state.testSelection
	);
	const { userId } = useSelector((state) => state.userDetails);
	const navigate = useNavigate();
	const location = useLocation();
	const dispatch = useDispatch();

	// Check if user just completed an exam - look for state in the location
	const justCompletedExam = location.state?.fromExam || false;

	// Effect to prevent navigation back to exam page only if coming directly from an exam
	useEffect(() => {
		// Only apply navigation prevention if the user just completed an exam
		if (!justCompletedExam) return;

		// Block browser back button
		const preventNavigation = (e) => {
			// Navigate to home page
			navigate("/", { replace: true });
		};

		// Handle popstate (back button) events
		const handlePopState = (e) => {
			// If user tries to go back, navigate to home page
			navigate("/", { replace: true });
		};

		// Add event listeners
		window.addEventListener("beforeunload", preventNavigation);
		window.addEventListener("popstate", handlePopState);

		// Modify browser history to replace any exam page entries
		window.history.pushState(null, "", location.pathname);

		return () => {
			// Cleanup
			window.removeEventListener("beforeunload", preventNavigation);
			window.removeEventListener("popstate", handlePopState);
		};
	}, [navigate, location.pathname, justCompletedExam]);

	useEffect(() => {
		const examReattempts = async () => {
			const response = await getExamReattempts(userId, examId, attempt);
			setReattempts(response.data);
		};
		examReattempts();
	}, [attempt]);

	const renderContent = () => {
		switch (selectedMenu) {
			case "testResult":
				return (
					<TestResult
						setWrongQuestions={setWrongQuestions}
						setExamNameTop={setExamName}
					/>
				);
			case "retakeTest":
				return <div>Retake the Test Content</div>;
			case "reattemptWrong":
				return <div>Reattempt Wrong Content</div>;
			default:
				return null;
		}
	};

	const callStartReattemptWrong = async () => {
		let reattemptCount = 0;
		if (reattempts?.length >= 0 && reattempts?.length < 3)
			reattemptCount = reattempts?.length + 1;
		if (reattempts?.length >= 3) {
			alert("only 3 reattempts allowed");
		}
		const response = await startReattemptWrong(
			userId,
			examId,
			attempt,
			reattempts?.length + 1,
			wrongQuestions,
			examName
		);
		dispatch(setReattemptId(response?.data));
		dispatch(selectTest("SATReattempt"));
		navigate("/test-instructions");
	};

	return (
		<div className='exam-score-container'>
			<div className='exam-score-column1'>
				<div className='exam-score-menu'>
					<div className='underline'>
						{firstName} {lastName}
					</div>
					<div className='exam-score-menu-items'>
						<div
							className={`exam-score-sub-menu-header ${
								selectedMenu === "testResult" && selectedTest !== "SATReattempt"
									? "active"
									: ""
							}`}
							onClick={() => {
								dispatch(selectTest("SAT"));
								dispatch(setReattemptId(null));
								setSelectedMenu("testResult");
							}}>
							<div>Test Result</div>
						</div>
						<div
							className={`exam-score-sub-menu-header ${
								selectedMenu === "retakeTest" ? "active" : ""
							}`}
							onClick={() =>
								selectedTest === "SFT" ? navigate("/SFT") : navigate("/exam")
							}>
							<div>Retake the Test</div>
						</div>
						{selectedTest !== "SFT" && (
							<div
								className={`exam-score-sub-menu-header ${
									selectedMenu === "reattemptWrong" ? "active" : ""
								}`}
								onClick={callStartReattemptWrong}>
								{/* onClick={() => setSelectedMenu("reattemptWrong")}> */}
								<div>Reattempt Wrong</div>
							</div>
						)}
						{reattempts?.length != 0 &&
							reattempts?.map((reattempt, index) => (
								<div
									className={`exam-score-sub-menu-header ${
										selectedMenu === "testResult" &&
										selectedTest === "SATReattempt" &&
										reattempt?.REATTEMPT_ID === reattemptId
											? "active"
											: ""
									}`}
									key={index}
									// onClick={callStartReattemptWrong}
									style={{ marginLeft: "1rem" }}
									onClick={() => {
										dispatch(setReattemptId(reattempt?.REATTEMPT_ID));
										dispatch(selectTest("SATReattempt"));
										setSelectedMenu("testResult");
									}}>
									<div>Reattempt {reattempt?.reattemptNumber}</div>
								</div>
							))}
					</div>
				</div>
			</div>
			<div className='exam-score-column2'>{renderContent()}</div>
		</div>
	);
};

export default ExamScore;
